import dayjs from "dayjs";
import type { EntityAdapter } from "@/components/tables/entityAdapters/entityAdapter";

export const accidentBookEntityAdapter: EntityAdapter = {
  entity: "accidentBook",
  finishCreatePayload: (result, values, ctx) => {
    if (ctx.subdomain === "admin") {
      return { ...values, company_subject: ctx.globalSubjectValue };
    }
    if (ctx.subdomain === "manage") {
      return {
        ...values,
        approved_by: ctx.currentUserSubjectId,
        approved_on: dayjs().toISOString(),
        impersonate_subject: ctx.selectedChildCompanySubjectId,
      };
    }
    return result;
  },
};
